import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExclamationCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/ExclamationCircleTwoTone";
import AntdIcon from '../components/AntdIcon';
var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ExclamationCircleTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ExclamationCircleTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ExclamationCircleTwoTone';
}
export default RefIcon;